import React, { FC } from "react";

export const DesktopIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 18.5H14.5M10.5 18.5H6.5M10.5 18.5V14.5M10.5 14.5C14.5 14.5 18 14.1667 18.5 13.8333C19 13.5 19.5 10.6667 19.5 8C19.5 5.33333 19 2.5 18.5 2.16667C18 1.83333 14.5 1.5 10.5 1.5C6.5 1.5 3 1.83333 2.5 2.16667C2 2.5 1.5 5.33333 1.5 8C1.5 10.6667 2 13.5 2.5 13.8333C3 14.1667 6.5 14.5 10.5 14.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownloadIcon = () => {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13V16.5C18 19.5577 14 19.5 10 19.5C6 19.5 2 19.5577 2 16.5V13M10 14L10 2M10 14L6 10M10 14L14 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="14"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12V16.5C18 19.5577 14 19.5 10 19.5C6 19.5 2 19.5577 2 16.5V12M10 2L10 14M10 2L14 6M10 2L6 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ClassroomIcon = () => {
  return (
    <svg
      width="31"
      height="22"
      viewBox="0 0 31 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7273 13.8571C27.6393 13.8571 30 16.7143 30 18.8571C30 20.0406 29.1147 21 28.0227 21H27.3636M22.0909 9.57143C24.2749 9.57143 26.0455 7.65265 26.0455 5.28571C26.0455 2.91878 24.2749 1 22.0909 1M6.27273 13.8571C3.36068 13.8571 1 16.7143 1 18.8571C1 20.0406 1.88526 21 2.97727 21H3.63636M8.90909 9.57143C6.72506 9.57143 4.95455 7.65265 4.95455 5.28571C4.95455 2.91878 6.72506 1 8.90909 1M21.4318 21H9.56818C8.47616 21 7.59091 20.0406 7.59091 18.8571C7.59091 15.2857 11.5455 13.8571 15.5 13.8571C19.4545 13.8571 23.4091 15.2857 23.4091 18.8571C23.4091 20.0406 22.5238 21 21.4318 21ZM19.4545 5.28571C19.4545 7.65265 17.684 9.57143 15.5 9.57143C13.316 9.57143 11.5455 7.65265 11.5455 5.28571C11.5455 2.91878 13.316 1 15.5 1C17.684 1 19.4545 2.91878 19.4545 5.28571Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CompetitionsIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 14H18.5858C19.4767 14 19.9229 12.9229 19.2929 12.2929L16.7071 9.70711C16.3166 9.31658 16.3166 8.68342 16.7071 8.29289L19.2929 5.70711C19.9229 5.07714 19.4767 4 18.5858 4H5V14ZM5 14V21"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FlagIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8335 58.3327H77.4409C81.153 58.3327 83.0121 53.8446 80.3872 51.2197L69.6131 40.4456C67.9859 38.8184 67.9859 36.1803 69.6131 34.5531L80.3872 23.779C83.0121 21.1541 81.153 16.666 77.4409 16.666H20.8335V58.3327ZM20.8335 58.3327V87.4993"
        stroke="currentColor"
        strokeWidth="6.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ReportsIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 16V12M12 16V8M8 16V14M3.5 12C3.5 5.5 5.5 3.5 12 3.5C18.5 3.5 20.5 5.5 20.5 12C20.5 18.5 18.5 20.5 12 20.5C5.5 20.5 3.5 18.5 3.5 12Z"
        stroke="#FCFDFF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CirclePower = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 12V7" />
      <path d="M16 9a5 5 0 1 1-8 0" />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 108 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.1836 90.8346H34.3378C25.3144 90.8346 17.9995 83.322 17.9995 74.0551V47.6593C17.9995 41.7918 20.9837 36.3505 25.8696 33.3094L46.2925 20.5977C51.4975 17.3581 58.0239 17.3581 63.2288 20.5977L83.6517 33.3094C88.5377 36.3505 91.5219 41.7918 91.5219 47.6593V74.0551C91.5219 83.322 84.2068 90.8346 75.1836 90.8346Z"
        stroke="currentColor"
        strokeWidth="8.28723"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5112 74.0547H67.0187"
        stroke="currentColor"
        strokeWidth="8.28723"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FileIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.125 5.95801H4.95833M3.125 7.79134H5.875M4.99106 1.15892V3.13162C4.99106 3.63788 5.40147 4.04829 5.90773 4.04829H7.86849M4.99106 1.15892C4.83492 1.14986 4.67133 1.14551 4.5 1.14551C1.87132 1.14551 1.0625 2.17002 1.0625 5.49967C1.0625 8.82933 1.87132 9.85384 4.5 9.85384C7.12868 9.85384 7.9375 8.82933 7.9375 5.49967C7.9375 4.95636 7.91596 4.47442 7.86849 4.04829M4.99106 1.15892L7.86849 4.04829"
        stroke="currentColor"
        strokeWidth="0.6875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AssessmentIcon = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.69856 9.84377H9.59439M6.61516 2.84375L2.49087 7.34298C2.18899 7.6723 1.95064 8.07205 1.87808 8.53101C1.80482 8.99442 1.78044 9.56951 2.03183 9.84375C2.28322 10.118 2.81038 10.0914 3.23517 10.0115C3.65589 9.93232 4.02233 9.6723 4.32421 9.34298L8.4485 4.84375M6.61516 2.84375C6.61516 2.84375 7.99016 1.34375 8.90683 2.34375C9.8235 3.34375 8.4485 4.84375 8.4485 4.84375M6.61516 2.84375L8.4485 4.84375"
        stroke="#FAFBFF"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Logout = (size?: number, className?: string) => {
  return (
    <svg
      className={className}
      width={size || "1em"}
      height={size || "1em"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4L17.5 4C20.5577 4 20.5 8 20.5 12C20.5 16 20.5577 20 17.5 20H14M3 12L15 12M3 12L7 8M3 12L7 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon: FC<{ size?: number; className?: string }> = ({
  size,
  className,
}) => {
  return (
    <svg
      className={className}
      width={size || "1em"}
      height={size || "1em"}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49884 15.5V16.5C5.49884 18.1569 6.84199 19 8.49884 19C10.1557 19 11.4988 18.1569 11.4988 16.5V15.5M2.49883 6.5C2.49883 3.18629 5.18512 1.5 8.49883 1.5C11.8125 1.5 14.4988 3.18629 14.4988 6.5C14.4988 8.43916 15.2039 10.6133 15.9304 12.3389C16.5336 13.7717 15.521 15.5 13.9664 15.5H3.03121C1.47662 15.5 0.464023 13.7717 1.06726 12.3389C1.79377 10.6133 2.49883 8.43916 2.49883 6.5Z"
        stroke="#F6FBFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PeopleIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 107 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M85.1306 44.5653C95.0877 44.5653 103.16 53.5798 103.16 60.3407C103.16 64.0746 100.133 67.1016 96.3987 67.1016H94.1451M76.1161 31.0435C83.5839 31.0435 89.6378 24.9896 89.6378 17.5218C89.6378 10.0539 83.5839 4 76.1161 4M22.029 44.5653C12.0719 44.5653 4 53.5798 4 60.3407C4 64.0746 7.02695 67.1016 10.7609 67.1016H13.0145M31.0435 31.0435C23.5757 31.0435 17.5218 24.9896 17.5218 17.5218C17.5218 10.0539 23.5757 4 31.0435 4M73.8624 67.1016H33.2972C29.5632 67.1016 26.5363 64.0746 26.5363 60.3407C26.5363 49.0725 40.058 44.5653 53.5798 44.5653C67.1016 44.5653 80.6233 49.0725 80.6233 60.3407C80.6233 64.0746 77.5964 67.1016 73.8624 67.1016ZM67.1016 17.5218C67.1016 24.9896 61.0477 31.0435 53.5798 31.0435C46.1119 31.0435 40.058 24.9896 40.058 17.5218C40.058 10.0539 46.1119 4 53.5798 4C61.0477 4 67.1016 10.0539 67.1016 17.5218Z"
        stroke="currentColor"
        strokeWidth="6.76088"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NetworkIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.68439 10.6578L15.3124 7.34378M15.3156 16.6578L8.69379 13.3469M21 6C21 7.65685 19.6569 9 18 9C16.3431 9 15 7.65685 15 6C15 4.34315 16.3431 3 18 3C19.6569 3 21 4.34315 21 6ZM9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12ZM21 18C21 19.6569 19.6569 21 18 21C16.3431 21 15 19.6569 15 18C15 16.3431 16.3431 15 18 15C19.6569 15 21 16.3431 21 18Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const CodeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 8C17 8 17.8 8.33333 19.2 9.66667C20.6 11 21 12 21 12C21 12 20.6 13 19.2 14.3333C17.8 15.6667 17 16 17 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16C9 16 8.2 15.6667 6.8 14.3333C5.4 13 5 12 5 12C5 12 5.4 11 6.8 9.66667C8.2 8.33333 9 8 9 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9753 5.95293C14.9753 5.95293 13.3236 10.4877 12.9983 11.5C12.673 12.5124 11.3044 17.3777 11.3044 17.3777"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CogIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-none"
    >
      <path
        d="M9.5 1H11.5C12.0523 1 12.5 1.44772 12.5 2V2.56879C12.5 2.99659 12.7871 3.36825 13.1822 3.53228C13.5775 3.69638 14.0377 3.63384 14.3403 3.33123L14.7426 2.92891C15.1331 2.53838 15.7663 2.53838 16.1568 2.92891L17.571 4.34312C17.9616 4.73365 17.9615 5.36681 17.571 5.75734L17.1688 6.1596C16.8661 6.46223 16.8036 6.92247 16.9677 7.31774C17.1317 7.71287 17.5034 8 17.9313 8L18.5 8C19.0523 8 19.5 8.44771 19.5 9V11C19.5 11.5523 19.0523 12 18.5 12H17.9312C17.5034 12 17.1318 12.2871 16.9677 12.6822C16.8036 13.0775 16.8661 13.5377 17.1688 13.8403L17.571 14.2426C17.9616 14.6331 17.9616 15.2663 17.571 15.6568L16.1568 17.071C15.7663 17.4616 15.1331 17.4616 14.7426 17.071L14.3403 16.6688C14.0377 16.3661 13.5775 16.3036 13.1822 16.4677C12.7871 16.6318 12.5 17.0034 12.5 17.4312V18C12.5 18.5523 12.0523 19 11.5 19H9.5C8.94772 19 8.5 18.5523 8.5 18V17.4313C8.5 17.0034 8.21287 16.6317 7.81774 16.4677C7.42247 16.3036 6.96223 16.3661 6.6596 16.6688L6.25732 17.071C5.86679 17.4616 5.23363 17.4616 4.84311 17.071L3.42889 15.6568C3.03837 15.2663 3.03837 14.6331 3.42889 14.2426L3.83123 13.8403C4.13384 13.5377 4.19638 13.0775 4.03228 12.6822C3.86825 12.2871 3.49659 12 3.06879 12H2.5C1.94772 12 1.5 11.5523 1.5 11V9C1.5 8.44772 1.94772 8 2.5 8L3.06877 8C3.49658 8 3.86825 7.71288 4.03229 7.31776C4.1964 6.9225 4.13386 6.46229 3.83123 6.15966L3.42891 5.75734C3.03838 5.36681 3.03838 4.73365 3.42891 4.34313L4.84312 2.92891C5.23365 2.53839 5.86681 2.53839 6.25734 2.92891L6.65966 3.33123C6.96228 3.63386 7.4225 3.6964 7.81776 3.53229C8.21288 3.36825 8.5 2.99658 8.5 2.56876V2C8.5 1.44772 8.94772 1 9.5 1Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.5 10C12.5 11.1046 11.6046 12 10.5 12C9.39543 12 8.5 11.1046 8.5 10C8.5 8.89543 9.39543 8 10.5 8C11.6046 8 12.5 8.89543 12.5 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ChevronRight: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width={13}
      height={13}
      viewBox="0 0 10 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 17.5L9 9.5L1 1.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BackIconCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10H15M5 10L9 6M5 10L9 14M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRightToggle = () => {
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.27778 0.999999L6.72222 1C7.15178 1 7.5 1.69642 7.5 2.55556L7.5 13.4444C7.5 14.3036 7.15178 15 6.72222 15L1.27778 15C0.848211 15 0.5 14.3036 0.5 13.4444L0.500001 2.55555C0.500001 1.69642 0.848212 0.999999 1.27778 0.999999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.01562 11L5.01563 8L3.01563 5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ModuleIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9405 15H2.05165C1.19254 15 0.496094 14.3036 0.496094 13.4444V2.55556C0.496094 1.69645 1.19254 1 2.05165 1H12.9405C13.7997 1 14.4961 1.69645 14.4961 2.55556V13.4444C14.4961 14.3036 13.7997 15 12.9405 15Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.80252 6.44434L2.44141 7.99989L3.80252 9.55545"
        fill="transparent"
      />
      <path
        d="M3.80252 6.44434L2.44141 7.99989L3.80252 9.55545"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.55078 15V1V15Z" fill="transparent" />
      <path
        d="M5.55078 15V1"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PublishIcon = () => {
  return (
    <svg
      width="14"
      height="23"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 7V6C5 3.23858 7.23858 1 10 1C12.7614 1 15 3.23858 15 6V7C17.2091 7 19 8.79086 19 11C19 12.4806 18.1956 13.8084 17 14.5M5 7C2.79086 7 1 8.79086 1 11C1 12.4806 1.8044 13.8084 3 14.5M5 7C5.43285 7 5.84965 7.06875 6.24006 7.19594M10 9V18M10 9L13 12M10 9L7 12"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserCode = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9M1 5H17M1 5V11C1 17.3668 2.12797 18.5 9 18.5C15.872 18.5 17 17.3668 17 11V5M1 5L2.44721 2.10557C2.786 1.428 3.47852 1 4.23607 1H13.7639C14.5215 1 15.214 1.428 15.5528 2.10557L17 5"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DangerIcon = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size || "20"}
      height={size || "63"}
      viewBox="0 0 20 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6875 53.1562C19.6875 58.5841 15.2716 63 9.84375 63C4.41591 63 0 58.5841 0 53.1562C0 47.7284 4.41591 43.3125 9.84375 43.3125C15.2716 43.3125 19.6875 47.7284 19.6875 53.1562ZM1.13941 3.10066L2.81285 36.5694C2.89148 38.1411 4.18864 39.375 5.76229 39.375H13.9252C15.4989 39.375 16.796 38.1411 16.8746 36.5694L18.5481 3.10066C18.6324 1.41381 17.2876 0 15.5987 0H4.08885C2.39991 0 1.05513 1.41381 1.13941 3.10066Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
};

export const CodeFolder = ({ size }: { size?: number }) => {
  return (
    <svg
      width={size || "24"}
      height={size || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.352 8.79168C22.9142 8.23776 22.2998 7.896 21.5952 7.80576C21.2275 6.14496 19.8912 4.93248 18.3014 4.93248H11.5469C10.5667 4.79808 10.2874 4.51584 10.1386 4.04928C9.75264 2.3712 8.4048 1.20288 6.85056 1.20288H3.40128C1.52544 1.20288 0 2.90592 0 4.99968V19.0003C0 19.8202 0.2304 20.5978 0.66528 21.2544C0.75648 21.4435 0.86496 21.6221 0.9936 21.7853C1.50912 22.4371 2.26848 22.7971 3.13248 22.7971H18.2995C19.3296 22.7971 20.2838 22.2883 20.9318 21.3994C21.4915 20.7926 21.9178 20.0285 22.1174 19.1894L23.8819 11.7667C24.1498 10.6416 23.9558 9.5568 23.351 8.79168H23.352ZM3.40032 2.83488H6.8496C7.64352 2.83488 8.34336 3.49344 8.55168 4.43712L8.568 4.49856C9.1056 6.26208 10.7635 6.47616 11.3875 6.5568L11.4394 6.56352H18.3005C18.9965 6.56352 19.6003 7.05696 19.8864 7.77984H6.31488C4.50432 7.77984 2.70912 9.3648 2.22912 11.3875L1.63296 13.895V4.99968C1.63296 3.8064 2.42592 2.83488 3.40128 2.83488H3.40032ZM20.5296 18.8112C20.3962 19.3718 20.1005 19.8941 19.7222 20.303L19.7203 20.3011C19.2182 20.8416 18.5875 21.1642 18.0336 21.1642H3.13344C2.7696 21.1642 2.48064 21.0326 2.2752 20.7734C2.21568 20.6976 2.1648 20.6122 2.12256 20.521H2.12448C1.98144 20.2061 1.944 19.8077 2.01312 19.3843C2.01408 19.3757 2.016 19.368 2.01696 19.3594C2.02656 19.3027 2.03808 19.2461 2.05152 19.1885L3.816 11.7658C4.11936 10.4899 5.26368 9.4128 6.31488 9.4128H21.215C21.5789 9.4128 21.8669 9.54432 22.0714 9.80256C22.3642 10.1731 22.4458 10.751 22.2941 11.3875L20.5296 18.8102V18.8112ZM9.6912 17.711C9.56736 17.8666 9.38976 17.9645 9.192 17.9866C9.16416 17.9894 9.13632 17.9914 9.10848 17.9914C8.94048 17.9914 8.77824 17.9347 8.6448 17.8282L6.36672 16.0042C6.18912 15.8621 6.08736 15.6499 6.08736 15.4224C6.08736 15.1949 6.18912 14.9827 6.36672 14.8406L8.6448 13.0166C8.80032 12.8918 8.99424 12.8352 9.192 12.8582C9.38976 12.8803 9.56736 12.9782 9.6912 13.1338C9.94752 13.4544 9.89568 13.9248 9.57504 14.1811L8.02368 15.4234L9.57504 16.6656C9.89568 16.9219 9.94752 17.3923 9.6912 17.713V17.711ZM17.9136 15.4214C17.9136 15.649 17.8118 15.8611 17.6342 16.0032L15.3562 17.8272C15.2227 17.9338 15.0605 17.9904 14.8925 17.9904C14.8646 17.9904 14.8368 17.9885 14.809 17.9856C14.6112 17.9635 14.4336 17.8656 14.3098 17.7101C14.0534 17.3894 14.1053 16.919 14.4259 16.6627L15.9773 15.4205L14.4259 14.1782C14.1053 13.9219 14.0534 13.4515 14.3098 13.1309C14.4346 12.9754 14.6112 12.8774 14.809 12.8554C15.0077 12.8333 15.2016 12.8899 15.3562 13.0138L17.6342 14.8378C17.8118 14.9798 17.9136 15.192 17.9136 15.4195V15.4214ZM13.6272 12.4339L11.8051 18.8179C11.7504 19.009 11.6246 19.1683 11.4509 19.2643C11.3386 19.3267 11.2147 19.3584 11.0899 19.3584C11.0208 19.3584 10.9517 19.3488 10.8845 19.3296C10.4899 19.2163 10.2605 18.8035 10.3728 18.408L12.1949 12.024C12.2496 11.833 12.3754 11.6736 12.5491 11.5776C12.7229 11.4806 12.9245 11.4576 13.1155 11.5123C13.5101 11.6256 13.7395 12.0384 13.6272 12.4339Z"
        fill="white"
      />
    </svg>
  );
};

export const GlobeIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75M18.75 9.75C18.75 4.77944 14.7206 0.75 9.75 0.75M18.75 9.75H0.75M9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75M9.75 18.75C9.75 18.75 13.75 15.75 13.75 9.75C13.75 3.75 9.75 0.75 9.75 0.75M9.75 18.75C9.75 18.75 5.75 15.75 5.75 9.75C5.75 3.75 9.75 0.75 9.75 0.75M0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75"
        stroke="#05CA75"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const ThemeIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.71814 14.7819C2.87291 16.9654 5.17876 17.75 9.25 17.75C14.8755 17.75 17.1304 16.252 17.6353 11.6353M1.71814 14.7819C1.02924 13.4792 0.75 11.6788 0.75 9.25C0.75 2.75 2.75 0.75 9.25 0.75C15.75 0.75 17.75 2.75 17.75 9.25C17.75 10.1245 17.7138 10.9176 17.6353 11.6353M1.71814 14.7819L4.83579 11.6642C5.61684 10.8832 6.88317 10.8832 7.66422 11.6642L7.83579 11.8358C8.61684 12.6168 9.88317 12.6168 10.6642 11.8358L12.8358 9.66422C13.6168 8.88317 14.8832 8.88317 15.6642 9.66422L17.6353 11.6353M7.941 6.096C7.941 7.115 7.114 7.942 6.095 7.942C5.077 7.942 4.25 7.115 4.25 6.096C4.25 5.077 5.077 4.25 6.095 4.25C7.114 4.25 7.941 5.077 7.941 6.096Z"
        stroke="#05CA75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SettingsIcon = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 2.75L6.75 2.75M6.75 2.75C6.75 3.85457 7.64543 4.75 8.75 4.75C9.85457 4.75 10.75 3.85457 10.75 2.75M6.75 2.75C6.75 1.64543 7.64543 0.75 8.75 0.75C9.85457 0.75 10.75 1.64543 10.75 2.75M10.75 2.75L16.75 2.75M0.75 9.75L12.75 9.75M12.75 9.75C12.75 10.8546 13.6454 11.75 14.75 11.75C15.8546 11.75 16.75 10.8546 16.75 9.75C16.75 8.64543 15.8546 7.75 14.75 7.75C13.6454 7.75 12.75 8.64543 12.75 9.75ZM4.75 16.75L16.75 16.75M4.75 16.75C4.75 15.6454 3.85457 14.75 2.75 14.75C1.64543 14.75 0.75 15.6454 0.75 16.75C0.75 17.8546 1.64543 18.75 2.75 18.75C3.85457 18.75 4.75 17.8546 4.75 16.75Z"
        stroke="#05CA75"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
